// A new purchase order's draft (docs/plans/dialog-safety.md): what was typed on the editor,
// kept on this device by `lib/drafts.ts` until the order is saved. Product ids and typed
// values only; the editor reads the products again when the draft is continued. Pure.

export interface PoDraftLine {
  productId: string
  qtyMilli: number | null
  costPaisa: number | null
}

export interface PoDraft {
  supplierId: string
  locationId: string | null
  expected: string
  notes: string
  lines: PoDraftLine[]
}

const obj = (v: unknown): Record<string, unknown> | null =>
  v && typeof v === 'object' && !Array.isArray(v) ? (v as Record<string, unknown>) : null
const str = (v: unknown) => (typeof v === 'string' ? v : '')
const int = (v: unknown) => (typeof v === 'number' && Number.isSafeInteger(v) ? v : null)

/** The draft as read from storage, or null when it is not one. */
export function parsePoDraft(v: unknown): PoDraft | null {
  const d = obj(v)
  if (!d || !Array.isArray(d.lines)) return null
  const lines: PoDraftLine[] = []
  for (const raw of d.lines) {
    const l = obj(raw)
    if (!l || typeof l.productId !== 'string' || !l.productId) continue
    lines.push({ productId: l.productId, qtyMilli: int(l.qtyMilli), costPaisa: int(l.costPaisa) })
  }
  return {
    supplierId: str(d.supplierId),
    locationId: typeof d.locationId === 'string' && d.locationId ? d.locationId : null,
    expected: str(d.expected),
    notes: str(d.notes),
    lines,
  }
}

/** Worth keeping: a line, or a note. */
export function poDraftHasWork(d: PoDraft): boolean {
  return d.lines.length > 0 || d.notes.trim() !== ''
}
